import * as React from 'react';
import { Notification } from '@wix/design-system';
import { WithTranslation, withTranslation } from 'react-i18next';

interface GeneralErrorNotificationProps extends WithTranslation {
  showGeneralError: boolean;
  onClose: () => void;
}
export const GeneralErrorNotification = withTranslation()(
  ({ showGeneralError, onClose, t }: GeneralErrorNotificationProps) => {
    return (
      <Notification
        autoHideTimeout={4000}
        theme="error"
        show={showGeneralError}
        type="sticky"
        onClose={() => {
          onClose();
        }}
      >
        <Notification.TextLabel>
          {t('translation:price_quote_view.general-warning.title')}
        </Notification.TextLabel>
        <Notification.CloseButton />
      </Notification>
    );
  },
);
